<footer class="site-footer">
    <div class="footer-top">
        <div class="container">
            <div class="row align-items-start">

                <div class="col-12 col-md-4 footer-brand mb-4 mb-md-0">
                    <a routerLink="/ciudadano" class="footer-logo-link">
                        <app-brand-mark height="44"></app-brand-mark>
                    </a>
                    <p class="footer-desc mt-3">{{ theme.brand.description }}</p>
                </div>

                <div class="col-6 col-md-2 mb-4 mb-md-0">
                    <h6 class="footer-heading">Portal</h6>
                    <ul class="footer-list">
                        <li><a routerLink="/ciudadano/tramites" [queryParams]="{search: 'predial'}">Predial</a></li>
                        <li><a routerLink="/ciudadano/tramites">Trámites</a></li>
                        <li><a routerLink="/reporte">Reporte ciudadano</a></li>
                        <li><a routerLink="/ciudadano/empleos">Bolsa de trabajo</a></li>
                        <li><a routerLink="/ciudadano/limpia-publica/suscribirme">Limpia pública</a></li>
                        <li><a routerLink="/ciudadano/iniciar-sesion">Iniciar sesión</a></li>
                        <li><a routerLink="/ciudadano/crear-cuenta">Crear cuenta</a></li>
                    </ul>
                </div>

                <div class="col-6 col-md-2 mb-4 mb-md-0">
                    <h6 class="footer-heading">Legal</h6>
                    <ul class="footer-list">
                        <li><a href="#">Aviso de privacidad</a></li>
                        <li><a href="#">Términos y condiciones</a></li>
                        <li><a href="#">Preguntas frecuentes</a></li>
                    </ul>
                </div>

                <div class="col-12 col-md-4 mb-4 mb-md-0">
                    <h6 class="footer-heading">Contacto</h6>
                    <ul class="footer-list footer-contact">
                        <li *ngIf="theme.brand.contact.address">{{ theme.brand.contact.address }}</li>
                        <li *ngIf="theme.brand.contact.phoneDisplay">{{ theme.brand.contact.phoneDisplay }}</li>
                        <li *ngIf="theme.brand.contact.email">{{ theme.brand.contact.email }}</li>
                    </ul>
                </div>

            </div>
        </div>
    </div>

    <div class="footer-bottom">
        <div class="container">
            <span>© {{ year }} {{ theme.brand.copyrightHolder }}. Todos los derechos reservados.</span>
        </div>
    </div>
</footer>
